var AjaxPaginate = function ajaxPaginateConstructor(config) {
  var settings = config || {};
  var defaultSettings = {
    container: '#AjaxPaginateContainer',
    pagination: '#AjaxPaginateNext',
    loadingText: 'Loading',
  };
  this.settings = Object.assign(defaultSettings, settings);

  this.addClickListener = this.addClickListener.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.addUrlChangeListener = this.addUrlChangeListener.bind(this);
  this.destroy = this.destroy.bind(this);
  this.setElements = this.setElements.bind(this);
  this.currentUrl = window.location.href;

  this.addUrlChangeListener();
  this.initialize();
};

AjaxPaginate.prototype.setElements = function setElements() {
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
};

AjaxPaginate.prototype.initialize = function initialize() {
  this.setElements();
  if (this.containerElement) {
    this.addClickListener();
  }
};

AjaxPaginate.prototype.addUrlChangeListener = function addUrlChangeListener() {
  setInterval(
    function checkForUrlChange() {
      if (this.currentUrl !== window.location.href) {
        this.currentUrl = window.location.href;
        urlChangeTimeout = setTimeout(() => {
          this.initialize();
        }, 1000);
      }
    }.bind(this),
    1000
  );
};

AjaxPaginate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;
    if (this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

AjaxPaginate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

AjaxPaginate.prototype.loadMore = function loadMore() {
  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function success() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
      this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      this.paginationElement.innerHTML = newPagination.innerHTML;
      this.initialize();
    }
  }.bind(this);
  this.request.open('GET', this.nextPageUrl);
  this.request.responseType = 'document';
  this.request.send();
};

AjaxPaginate.prototype.destroy = function destroy() {
  this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
  return this;
};
